import axios from "../../common/api/axios";
import RACI from "../ProjectsPage/SingleProjectPage/tabs/RACI/raci.interface";

export const getAllRACI = async (): Promise<RACI[]> => {
    const response: RACI[] = (await axios.get(`/raci/`)).data;
    console.log('raci', response);
    return response;
};
